/* eslint-disable no-useless-return */
export function componentLoader<T>(
	lazyComponent: () => Promise<T>,
	attemptsLeft: number,
): Promise<T> {
	return new Promise((resolve, reject) => {
		lazyComponent()
			.then(resolve)
			.catch((error: unknown) => {
				// let us retry after 2000 ms
				setTimeout(() => {
					if (attemptsLeft === 1) {
						reject(error);
						return;
					}

					componentLoader(lazyComponent, attemptsLeft - 1).then(resolve, reject);
				}, 2000);
			});
	});
}
